module.exports = __webpack_public_path__ + "img/black-friday.97184c7.jpeg";